/**
 * Subject palette, shared by the colour picker and the server-side validator.
 * Kept in its own pure module so the web bundle does not pull in Convex
 * function builders just to render swatches.
 */
export const SUBJECT_COLORS = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#84CC16",
  "#22C55E",
  "#14B8A6",
  "#06B6D4",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#EC4899",
  "#64748B",
] as const;

export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;
